export function getEnv() {
    if (window.location.origin.indexOf('waimai.st.meituan.com') !== -1) {
        return 'stage';
    }
    if (window.location.origin.indexOf('waimai.test.sankuai.com') !== -1) {
        return 'test';
    }
    return 'prod';
}
